import Phaser from 'phaser';
import TitleScene from './scenes/TitleScene.js';
import GameScene from './scenes/GameScene.js';

// Game configuration with responsive scaling for expanded 4x world
const config = {
    type: Phaser.AUTO,
    width: 2048,  // Expanded world width
    height: 1280, // Expanded world height
    parent: 'game',
    backgroundColor: '#87CEEB',
    scale: {
        mode: Phaser.Scale.RESIZE,
        autoCenter: Phaser.Scale.CENTER_BOTH,
        min: {
            width: 320,
            height: 200
        },
        max: {
            width: 3840,
            height: 2400
        }
    },
    physics: {
        default: 'arcade',
        arcade: {
            gravity: { y: 800 },
            debug: false
            // REMOVED world bounds - no invisible walls, free exploration
        }
    },
    scene: [TitleScene, GameScene]
};

// Initialize the game
const game = new Phaser.Game(config);

// Initialize Hub Controls for mobile (from dreamdealer.dev)
// Layer 1 init — hub-controls.js owns hardware (gamepad polling + touch D-pad).
// Layer 2 — each scene polls HubControls.getState() / justPressed() per frame
// and merges with its own Phaser keyboard bindings.  No synthetic key events.
function initHubControls() {
    if (typeof HubControls !== 'undefined') {
        HubControls.init({
            simulateKeys: false,  // Game owns keyboard — no synthetic events from hub
            hideExisting: true
        });
    } else {
        // Script may still be loading, try again
        setTimeout(initHubControls, 100);
    }
}
initHubControls();

// Handle window resize
window.addEventListener('resize', () => {
    // Let the scene handle the resize
    setTimeout(() => {
        if (game.scene.scenes[0] && game.scene.scenes[0].handleOrientationChange) {
            game.scene.scenes[0].handleOrientationChange();
        }
    }, 100);
});

export default game; 